/**
 * Process configuration types
 */
export enum ProcessConfigurationsType {
  DEACTIVATED = 'deactivated',
  HIGHER = 'higher',
  LOWER = 'lower',
  BOTH = 'both',
}
